const initialState = [];


export default function management(state=initialState, action) {


    switch (action.type) {

        case 'FETCH_USERS':
            return action;

        case 'SELECT_USER':

            return  action;

        case 'ADD_USER':
            return [...state, action.note];

        case 'FETCH_INSTITUTION':
            return action;

        case 'UPDATE_PERSON':
            return action;

        case 'UPDATE_CONTACT':
            return action;

        case 'DELETE_CONTACT':
            return action;

        case 'USER_UPDATE_STATUS':
            return action;

        case 'ADD_NEW_USER':
            return action;

        case 'UPDATE_RFG':
            return action;

        case 'CONTACT_US':

            return action;


        default:
            return action;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/management.js